<template>
  <!-- 产品详情 -->
  <div class="productDetail">
    <!-- 头部 -->
    <headerNav activeIndex="academicCenter" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div
      class="pc"
      style="padding: 50px 72px 148px; background: #f8f8f8"
      id="mainNav"
    >
      <div class="maxWidth mainNav" style="width: 1200px" ref="mainNav">
        <div class="mainContent" style="">
          <div style="display: flex">
            <div
              style="
                flex: 1;
                background: #fff;
                padding: 40px;
                margin-right: 50px;
              "
            >
              <div
                style="
                  text-align: center;
                  border-bottom: 1px solid #e5e5e5;
                  padding-bottom: 10px;
                "
              >
                <div style="color: #719468; font-size: 36px">
                  {{ newsDetail.title }}
                </div>
                <div
                  style="
                    font-size: 14px;
                    color: #535353;
                    line-height: 23px;
                    margin-top: 20px;
                  "
                >
                  <span style="margin-right: 16px"
                    >发布机构：{{ newsDetail.authorName }}</span
                  >
                  <span style="margin-right: 16px"
                    >发布时间：{{ newsDetail.releaseTime }}</span
                  >
                </div>
              </div>
              <div
                style="margin-top: 50px; line-height: 2em"
                class="ql-editor"
                v-html="newsDetail.content"
              ></div>
            </div>
            <div
              style="
                width: 300px;
                padding: 30px;
                background: #fff;
                height: max-content;
              "
            >
              <div
                style="
                  font-weight: 500;
                  color: #293a4c;
                  line-height: 28px;
                  border-bottom: #e6e6e6 1px solid;
                  width: 100%;
                  padding-bottom: 16px;
                "
              >
                论文排行
              </div>
              <div
                v-for="(item, index) of rankList"
                :key="index"
                class="lwRankingNav"
              >
                <div class="lwRankIndex" :style="index === 0?'background:#26B3AE;':index === 1?'background:#26B3AE;opacity: 0.8':index === 2?'background:#26B3AE;opacity: 0.6':''">{{ index+1 }}</div>
                <div class="lwRanking" @click="goLwDetail(item)">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile" style="">
      <div style="text-align: left; padding: 0.6rem 0.26rem 0.2rem">
        <div style="color: #719468; font-size: 22px; line-height: 1.5">
          {{ newsDetail.title }}
        </div>
        <div
          style="
            font-size: 14px;
            color: #0000004d;
            margin-top: 0.2rem;
            padding-bottom: 0.15rem;
            border-bottom: 1px solid #e5e5e5;
          "
        >
          <i class="el-icon-user" style="margin-right: 1px"></i>
          <span style="margin-right: 12px">{{ newsDetail.authorName }}</span>
          <i class="el-icon-date" style="margin-right: 1px"></i>
          <span style="margin-right: 12px">{{ newsDetail.releaseTime }}</span>
        </div>
      </div>
      <div
        style="
          margin-top: 0.1rem;
          line-height: 1.5;
          font-size: 17px;
          padding: 0 0.26rem;
        "
        class="ql-editor"
        v-html="newsDetail.content"
      ></div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import { findNewsById } from "@/api/news";
import { getacademicRanking } from "@/api/academic";
import { getConfByKey, updateReadingVolume } from "@/api/common";

export default {
  name: "newsDetail",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      mobile: false,
      newsDetail: {}, //产品详情
      rankList: [],
    };
  },
  mounted() {
    this.goDetail();
    this.getRanking();
  },
  methods: {
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
    },
    getRanking() {
      getacademicRanking().then((res) => {
        this.rankList = res.data;
      });
    },
    goDetail() {
      findNewsById({ id: this.$route.params.id })
        .then((response) => {
          if (response.data !== null) {
            this.newsDetail = response.data;
            this.postMessage(
              this.newsDetail.title,
              this.newsDetail.description,
              window.location.href,
              this.getUrlPrefix(this.newsDetail.images)
            );
            this.navIndex = this.$route.params.type;
            // updateReadingVolume({ id: this.$route.params.id }).then();
          } else {
            this.$router.replace({ name: "404" });
          }
        })
        .catch(() => {
          this.$router.replace({ name: "500" });
        });
    },
    goNew() {
      var path = `/newsCenter`;
      this.$router.push({ path });
    },
    goback() {
      var path = `/newsCenter${
        this.navIndex === 1 ? "#enterprise" : "#industry"
      }`;
      this.$router.push({ path });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },

    goLwDetail(obj) {
      if (obj.externalUrl && obj.externalUrl !== "") {
        window.open(obj.externalUrl, "_blank");
      } else {
        this.$router.push({
          name: "academicCenterDetail",
          query: { id: obj.id, type: 4 },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.productDetail {
  .maxWidth {
    width: 1067px;
    margin: 0 auto;
  }
  .lwRankingNav {
    margin-top: 24px;
    display: flex;
    line-height: 20px;
    align-items: center;
    .lwRankIndex{
       width: 30px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        float: left;
        background: #d9d9d9;
        text-align: center;
        font-size: 14px;
        margin: 0 6px 0 0;
        font-style: italic;
    }
    .lwRanking {
      font-weight: 400;
      color: #5b5c60;
      line-height: 20px;
      -webkit-line-clamp: 2;
      flex: 1;
    }
    .lwRanking:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/academicCenter/detail.vue